import clsx from 'clsx';
import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';
import SubmitButton from '../SubmitButton';
import { Actions } from '.';

export interface Props {
  selectedPrograms: number[];
  actions: Pick<Actions, 'back' | 'inviting'>;
}

function Submit({ actions, selectedPrograms }: Props) {
  return (
    <div className="flex mt-16">
      <div
        className={clsx(
          'cursor-pointer rounded-md bg-white text-teal-600 border-teal-600 px-3 py-2 text-sm',
          ' w-24 text-center mt-4 border mr-4',
        )}
        onClick={actions.back}
      >
        <T kind="Back" />
      </div>
      {fromEmpty(selectedPrograms)
        .map((programIds) => (
          <SubmitButton onClick={() => actions.inviting(programIds)} buttonText={'Next'} />
        ))
        .getOrElse(() => (
          <div
            className={clsx(
              'pointer-events-none rounded-md bg-gray-500 text-white px-3 py-2 text-sm w-24 text-center mt-4',
            )}
          >
            <T kind="Next" />
          </div>
        ))}
    </div>
  );
}

export default observer(Submit);
